import styles from './ContactDropdown.module.css';
import { useState } from 'react';
import Button from '../Button/Button';
import buttonStyles from '../Button/Button.module.css';

const ContactDropdown = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={styles.container}>
      <Button onClick={() => setIsOpen(prev => !prev)}
        className={`${styles.fullWidthButton} ${isOpen ? buttonStyles.roundTopOnly : ''}`}
        >
        {isOpen ? 'Hide Contact' : 'Contact'}
      </Button>

      <div className={`${styles.contactInfo} ${isOpen ? styles.open : ''}`}>
        <p>Email: kanina.1@icloud.com</p>
        <p>Phone: (940) 613-9620</p>
        <p>Location: Next door to Dollar General in Collinsville, TX</p>
        <iframe src="https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d831.1476961299605!2d-96.91272973045126!3d33.564006998334015!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMzPCsDMzJzUwLjQiTiA5NsKwNTQnNDMuNSJX!5e0!3m2!1sen!2sus!4v1756400466291!5m2!1sen!2sus" width="400" height="300" styles="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
      </div>
    </div>
  );
};

export default ContactDropdown;